import { GlobalOptions } from "./types";

export let config = {} as GlobalOptions;

/**
 * convenience method to load the path for the data from the sendgrid.
 * @param options
 */
export function loadGlobalOptions<T extends GlobalOptions>(options: T): T {
  if (options.apiHost) {
    const url = new URL(options.apiHost);
    options.apiHost = url.origin + "/v3/";
  }
  return (config = { ...config, ...options });
}

export const load = loadGlobalOptions;
